/* Built by Alpas Made. */
/*
 * Feedback widget, beta.
 *
 * WHO SEES IT. Everyone, while the theme setting "Show the beta feedback
 * button" is on (layout/theme.liquid passes it in as KC_FEEDBACK.everyone).
 * Holders of the `kc_team_bypass` cookie always
 * see it, setting on or off, and get the tester form: their recent clicks and
 * the account details the page showed (there is no test number field; the
 * server still accepts one from old drafts). A customer's report
 * carries only what the line under the form and the privacy policy say: the
 * page they were on and basic device details, plus the ids our own server gave
 * the calls this page made, so a report joins to the server's account of what
 * happened. On a layout that does not pass the setting (an older one) the
 * widget stays team only, which is how it behaved before the beta.
 *
 * WHY IT WATCHES FETCH: the expensive part of fixing a report is never
 * collecting it, it is working out afterwards what actually happened. Our own
 * endpoints stamp a request id (returned as x-vercel-id) and record their
 * outcome in audit_events, so capturing those ids here means a report joins
 * straight to the server's own account of the call that failed.
 *
 * "SENT" ONLY ON SERVER CONFIRMATION. The words are saved on this device (a
 * draft, with a key that stays the same across retries) before anything is
 * sent, and the panel says "sent" only when the server returns the reference
 * of the saved row. A retry after a timeout files ONE report and shows the
 * SAME reference.
 *
 * Everything is wrapped so this can never break the storefront. A feedback
 * widget that takes the shop down would be worse than no feedback widget.
 */
(function () {
  'use strict';

  var CFG = {};
  var tester = false;
  try {
    CFG = window.KC_FEEDBACK || {};
    tester = document.cookie.indexOf('kc_team_bypass=1') !== -1;
    if (!tester && CFG.everyone !== true) return;
    // The soft-launch overlay covers the shop: nothing to give feedback on yet.
    if (document.documentElement.classList.contains('kc-soft-launch-gated')) return;
    // Not inside the theme editor, where it would sit over the merchant's work.
    if (window.Shopify && window.Shopify.designMode) return;
  } catch (e) { return; }

  try { start(); } catch (e) { /* never break the storefront */ }

  function start() {
    var ENDPOINT = '/apps/credits/feedback';
    var DRAFT_KEY = 'kc_fb_draft';
    var MAX_FILES = 3;
    var MAX_SOURCE_BYTES = 12 * 1024 * 1024;   // what we will accept off the disk
    var MAX_EDGE = 1600;                        // longest side after downscale
    var JPEG_Q = 0.82;
    // The platform rejects a request body over about 4.5MB with a 413, and base64
    // inflates by ~37%, so a single untouched 5MB phone screenshot would fail.
    // Measured on the live platform: 4.0MB on the wire succeeded, 6.7MB returned
    // FUNCTION_PAYLOAD_TOO_LARGE. Hence downscaling below, and a budget here.
    var WIRE_BUDGET = 3.2 * 1024 * 1024;
    var MAX_CRUMBS = 20;
    var MAX_BODY = 4000;                        // the server refuses longer
    var COUNT_FROM = 3600;                      // show "characters left" past this
    var SEND_TIMEOUT = 60000;
    var PRIVACY_URL = '/policies/privacy-policy';

    var TYPES = [
      { v: 'broken', kind: 'bug', label: "Something's broken", hint: 'What were you doing, and what went wrong?' },
      { v: 'idea', kind: 'idea', label: 'An idea', hint: 'What would you like us to add or change?' },
      { v: 'question', kind: 'question', label: 'A question', hint: 'What would you like to know?' }
    ];
    var typeOf = function (v) {
      for (var i = 0; i < TYPES.length; i++) if (TYPES[i].v === v) return TYPES[i];
      return TYPES[0];
    };

    // Same loose check as the server: it only catches an obvious typo.
    var EMAIL = /^[^\s@]{1,64}@[^\s@.]+(?:\.[^\s@.]+)+$/;

    /* A password reset or account activation link carries its token in the
       path. Never send that anywhere. */
    function safePath(p) {
      return String(p || '').replace(/\/account\/(reset|activate)\/[^?#]*/i, '/account/$1/(removed)');
    }

    // ---- recent clicks trail -----------------------------------------------
    var crumbs = [];
    var requestIds = [];
    var hhmm = function () { return new Date().toTimeString().slice(0, 8); };

    function crumb(type, detail) {
      if (!tester) return;   // recent clicks are sent by testers only
      crumbs.push({ t: type, at: hhmm(), d: String(detail).slice(0, 200) });
      if (crumbs.length > MAX_CRUMBS) crumbs.shift();
    }
    crumb('view', safePath(location.pathname) + location.search);

    // Our own calls, with the id the server logged them under. Same-origin through
    // the App Proxy, so the header is readable; guarded anyway.
    var nativeFetch = window.fetch;
    if (typeof nativeFetch === 'function') {
      window.fetch = function (input, init) {
        var url = '';
        try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (e) {}
        var ours = url.indexOf('/apps/credits/') !== -1 && url.indexOf(ENDPOINT) === -1;
        var p = nativeFetch.apply(this, arguments);
        if (!ours) return p;
        return p.then(function (res) {
          try {
            var id = res.headers.get('x-vercel-id');
            if (id && requestIds.indexOf(id) === -1) requestIds.push(id);
            if (requestIds.length > 20) requestIds.shift();
            crumb('call', url.split('?')[0] + ' -> ' + res.status);
          } catch (e) {}
          return res;
        }, function (err) {
          try { crumb('call', url.split('?')[0] + ' -> network error'); } catch (e) {}
          throw err;
        });
      };
    }

    if (tester) {
      document.addEventListener('click', function (ev) {
        try {
          var t = ev.target.closest('button, a[href], [role="button"]');
          if (!t) return;
          if (t.closest('#kcFeedback')) return;           // our own UI is not news
          var label = (t.getAttribute('aria-label') || t.textContent || '').replace(/\s+/g, ' ').trim();
          if (label) crumb('click', label.slice(0, 60));
        } catch (e) {}
      }, true);
    }

    // ---- what the shop believes about this person (testers only) -----------
    var account = { member: null, balance: null, status: null, signedIn: Boolean(CFG.customerId) };

    function loadAccount() {
      // Best effort, and never blocking: if the dashboard call fails the report
      // is still worth having, it just carries less.
      if (!tester || !CFG.customerId) return Promise.resolve();
      return nativeFetch('/apps/credits/dashboard', { headers: { accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (!d || !d.ok) return;
          account.member = d.member;
          account.balance = d.balance;
          account.status = d.status;
        })
        .catch(function () {});
    }

    // ---- state -------------------------------------------------------------
    // A named state, never a boolean: "loading" cannot express "failed but the
    // words are safe", which is the state that matters most here.
    var phase = 'idle';       // idle | sending | sent | failed
    var failReason = null;    // network | rate | too_large | rejected
    var emailError = false;
    var shots = [];           // { dataUrl, w, h }
    var lastRef = null;
    var open = false;
    var noteText = '';

    function draft() {
      try { return JSON.parse(localStorage.getItem(DRAFT_KEY) || '{}') || {}; } catch (e) { return {}; }
    }
    function saveDraft(d) {
      try { localStorage.setItem(DRAFT_KEY, JSON.stringify(d)); } catch (e) {}
    }
    function clearDraft() {
      try { localStorage.removeItem(DRAFT_KEY); } catch (e) {}
    }
    /* The key covers a retry of the SAME report only. Once the words, type,
       email or screenshots change it is a different report and gets a new key
       on its next send. Keeping the old one let a retry after a lost response
       come back "duplicate" with the first reference while the server kept
       the first words and silently dropped the edit. */
    function forgetKey(d) {
      if (d) { delete d.key; delete d.keyFor; }
      return d;
    }
    function emailValue(d) {
      // The draft holds an email only when the person typed in the box, or
      // emptied it (an emptied box stays empty). Otherwise the box shows the
      // email of whoever is signed in on THIS page, so a shared browser never
      // offers one customer's address to the next person.
      return typeof d.email === 'string' ? d.email : (CFG.email || '');
    }
    /* Who a key was issued for: the account on this page plus the reply
       address, kept as a short fingerprint so the draft never stores an
       address nobody typed. When a failed send is retried after a sign in or
       sign out, the sender differs, so it is a different report and gets a new
       key; the old key would let the server keep the first sender's details. */
    function senderTag(email) {
      var s = String(CFG.customerId || '') + '|' + String(email || '').toLowerCase();
      var h = 2166136261;
      for (var i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619); }
      return (h >>> 0).toString(36);
    }

    function newKey() {
      try {
        if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
      } catch (e) {}
      return 'fb-' + Date.now() + '-' + Math.random().toString(16).slice(2);
    }

    var esc = function (s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    };

    // ---- style ---------------------------------------------------------------
    // Written here rather than in a stylesheet so the widget is one file. Every
    // rule is scoped to #kcFeedback and resets what the theme sets globally on
    // labels, buttons, inputs and headings (the theme uppercases and tracks
    // <label>, which would make every field label read as a shouted heading).
    var CSS = [
      '#kcFeedback{--kcfb-card:#1a1a1a;--kcfb-raised:#1f1f1f;--kcfb-line:rgba(255,255,255,.14);--kcfb-line-hover:rgba(255,255,255,.34);',
      '--kcfb-text:#f9f9f9;--kcfb-muted:#a8a8a8;--kcfb-red:#e02f2e;--kcfb-red-hover:#c8282a;--kcfb-red-deco:#e83433;--kcfb-ok:#7cb87c;--kcfb-focus:#69b3ff;',
      '--kcfb-body:var(--font-body-family,Inter),-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;',
      '--kcfb-display:var(--font-heading-family,Oswald),"Arial Narrow",sans-serif;',
      'font-family:var(--kcfb-body);font-size:15px;line-height:1.5;color:var(--kcfb-text);text-align:left;',
      'text-transform:none;letter-spacing:normal;-webkit-font-smoothing:antialiased}',
      '#kcFeedback *,#kcFeedback *::before,#kcFeedback *::after{box-sizing:border-box}',
      '#kcFeedback :where(button,input,textarea,label,fieldset,legend,h2,h3,p,a,code,span,small,b,dl,dt,dd,details,summary){',
      'font-family:inherit;text-transform:none;letter-spacing:normal;text-shadow:none}',
      '#kcFeedback :where(button,input,textarea){margin:0;box-shadow:none;-webkit-appearance:none;appearance:none}',
      '#kcFeedback svg{display:block;flex:none;fill:none}',
      '#kcFeedback .kcfb-vh{position:absolute!important;width:1px;height:1px;padding:0;margin:0;overflow:hidden;clip-path:inset(50%);white-space:nowrap;border:0}',

      /* launcher */
      '#kcFeedback .kcfb-launch{position:fixed;right:16px;bottom:16px;z-index:60;display:inline-flex;align-items:center;gap:8px;',
      'height:44px;min-height:44px;padding:0 12px 0 16px;cursor:pointer;border:1px solid var(--kcfb-red);border-radius:999px;',
      'background:var(--kcfb-red);color:#fff;font:500 15px/1 var(--kcfb-body);white-space:nowrap;',
      'box-shadow:0 8px 24px rgba(0,0,0,.5);transition:background-color .12s ease,border-color .12s ease}',
      '#kcFeedback .kcfb-launch:hover{background:var(--kcfb-red-hover);border-color:var(--kcfb-red-hover)}',
      '#kcFeedback .kcfb-launch svg{width:20px;height:20px}',

      /* panel */
      '#kcFeedback .kcfb-panel{position:fixed;right:16px;bottom:72px;z-index:61;width:400px;max-width:calc(100vw - 32px);',
      'max-height:min(640px,calc(100vh - 104px));max-height:min(640px,calc(100dvh - 104px));display:flex;flex-direction:column;',
      'background:var(--kcfb-card);color:var(--kcfb-text);border:1px solid var(--kcfb-line);border-radius:12px;',
      'box-shadow:0 24px 64px rgba(0,0,0,.6)}',
      '#kcFeedback .kcfb-head{flex:none;display:flex;align-items:center;gap:8px;padding:8px 8px 8px 16px;border-bottom:1px solid var(--kcfb-line)}',
      '#kcFeedback .kcfb-head h2{margin:0;padding:0;font:600 18px/1.2 var(--kcfb-display);text-transform:uppercase;letter-spacing:-.03em;color:var(--kcfb-text)}',
      '#kcFeedback .kcfb-x{margin-left:auto;width:44px;height:44px;padding:0;display:grid;place-items:center;border:0;border-radius:6px;',
      'background:none;color:var(--kcfb-muted);cursor:pointer;transition:background-color .12s ease}',
      '#kcFeedback .kcfb-x:hover{color:var(--kcfb-text);background:rgba(255,255,255,.08)}',
      '#kcFeedback .kcfb-x svg{width:20px;height:20px}',
      '#kcFeedback .kcfb-body{position:relative;flex:1 1 auto;min-height:0;overflow:auto;overscroll-behavior:contain;display:grid;gap:16px;padding:16px}',

      /* type chips */
      '#kcFeedback .kcfb-types{margin:0;padding:0;border:0;min-width:0;display:flex;flex-wrap:wrap;gap:8px}',
      '#kcFeedback .kcfb-chip{position:relative;flex:1 1 auto;display:inline-flex;align-items:center;justify-content:center;',
      'min-height:44px;margin:0;padding:8px 12px;cursor:pointer;white-space:nowrap;border:1px solid var(--kcfb-line);border-radius:999px;',
      'background:var(--kcfb-raised);color:var(--kcfb-text);font:500 14px/1.2 var(--kcfb-body);transition:border-color .12s ease,background-color .12s ease}',
      '#kcFeedback .kcfb-chip input{position:absolute;opacity:0;width:1px;height:1px;margin:0;pointer-events:none}',
      '#kcFeedback .kcfb-chip:hover{border-color:var(--kcfb-line-hover)}',
      '#kcFeedback .kcfb-chip.is-on{background:rgba(255,255,255,.10);border-color:var(--kcfb-text);box-shadow:inset 0 0 0 1px var(--kcfb-text)}',
      '#kcFeedback .kcfb-chip.is-focus{outline:2px solid var(--kcfb-focus);outline-offset:2px}',

      /* fields */
      '#kcFeedback .kcfb-field{display:grid;gap:8px;min-width:0}',
      '#kcFeedback .kcfb-label{display:flex;align-items:baseline;gap:8px;margin:0;font:600 14px/1.4 var(--kcfb-body);color:var(--kcfb-text)}',
      '#kcFeedback .kcfb-opt{font-size:13px;font-weight:400;color:var(--kcfb-muted)}',
      '#kcFeedback .kcfb-input{display:block;width:100%;min-height:44px;height:auto;padding:8px 12px;margin:0;',
      'font:400 16px/1.5 var(--kcfb-body);color:var(--kcfb-text);background:var(--kcfb-raised);',
      'border:1px solid var(--kcfb-line);border-radius:6px;outline:none;transition:border-color .12s ease}',
      '#kcFeedback textarea.kcfb-input{min-height:96px;max-height:240px;padding:12px;resize:vertical;field-sizing:content}',
      '#kcFeedback .kcfb-input::placeholder{color:var(--kcfb-muted);opacity:1}',
      '#kcFeedback .kcfb-input:hover{border-color:var(--kcfb-line-hover)}',
      '#kcFeedback .kcfb-input:focus-visible{outline:2px solid var(--kcfb-focus);outline-offset:2px;border-color:var(--kcfb-line-hover)}',
      '#kcFeedback .kcfb-input[aria-invalid="true"]{border-color:var(--kcfb-red-deco)}',
      '#kcFeedback .kcfb-help{display:flex;align-items:center;gap:8px;margin:0;font-size:13px;line-height:1.5;color:var(--kcfb-muted)}',
      '#kcFeedback .kcfb-help.is-err{color:var(--kcfb-text)}',
      '#kcFeedback .kcfb-help svg{width:16px;height:16px;color:var(--kcfb-red-deco)}',

      /* screenshots */
      '#kcFeedback .kcfb-drop{position:relative;display:flex;align-items:center;gap:12px;min-height:48px;margin:0;padding:12px;cursor:pointer;',
      'border:1px dashed var(--kcfb-line);border-radius:6px;font:400 14px/1.4 var(--kcfb-body);color:var(--kcfb-text);',
      'transition:border-color .12s ease,background-color .12s ease}',
      '#kcFeedback .kcfb-drop:hover{border-color:var(--kcfb-line-hover);background:rgba(255,255,255,.03)}',
      '#kcFeedback .kcfb-drop.is-focus{outline:2px solid var(--kcfb-focus);outline-offset:2px}',
      '#kcFeedback .kcfb-drop input{position:absolute;opacity:0;width:1px;height:1px;margin:0;pointer-events:none}',
      '#kcFeedback .kcfb-drop svg{width:20px;height:20px;color:var(--kcfb-muted)}',
      '#kcFeedback .kcfb-drop-text{display:flex;flex-wrap:wrap;align-items:baseline;column-gap:8px}',
      '#kcFeedback .kcfb-drop b{font-weight:600}',
      '#kcFeedback .kcfb-drop small{font-size:13px;color:var(--kcfb-muted)}',
      '#kcFeedback .kcfb-shots{display:flex;flex-wrap:wrap;gap:12px}',
      '#kcFeedback .kcfb-shot{position:relative;width:64px;height:64px}',
      '#kcFeedback .kcfb-shot img{display:block;width:100%;height:100%;object-fit:cover;border-radius:6px;border:1px solid var(--kcfb-line)}',
      '#kcFeedback .kcfb-rm{position:absolute;top:4px;right:4px;width:24px;height:24px;padding:0;display:grid;place-items:center;cursor:pointer;',
      'border-radius:999px;border:1px solid var(--kcfb-line);background:rgba(23,23,23,.9);color:var(--kcfb-text)}',
      '#kcFeedback .kcfb-rm::before{content:"";position:absolute;inset:-10px}',
      '#kcFeedback .kcfb-rm svg{width:12px;height:12px}',

      /* honeypot: off screen, out of the tab order, hidden from assistive tech */
      '#kcFeedback .kcfb-hp{position:absolute;left:-10000px;top:0;width:1px;height:1px;overflow:hidden}',

      /* tester details */
      '#kcFeedback .kcfb-ctx{border:1px solid var(--kcfb-line);border-radius:6px;background:rgba(255,255,255,.03)}',
      '#kcFeedback .kcfb-ctx summary{display:flex;align-items:center;min-height:44px;padding:8px 12px;cursor:pointer;font-size:14px;font-weight:600;color:var(--kcfb-text)}',
      '#kcFeedback .kcfb-ctx dl{margin:0;padding:0 12px 12px;display:grid;grid-template-columns:auto 1fr;gap:4px 12px;font-size:13px}',
      '#kcFeedback .kcfb-ctx dt{color:var(--kcfb-muted)}',
      '#kcFeedback .kcfb-ctx dd{margin:0;color:var(--kcfb-text);overflow-wrap:anywhere}',

      /* failed */
      '#kcFeedback .kcfb-msg{display:grid;grid-template-columns:20px minmax(0,1fr);column-gap:12px;row-gap:4px;padding:12px;border-radius:8px;',
      'font-size:14px;line-height:1.45;background:rgba(232,52,51,.10);border:1px solid rgba(232,52,51,.34)}',
      '#kcFeedback .kcfb-msg svg{grid-row:span 2;width:20px;height:20px;color:var(--kcfb-red-deco)}',
      '#kcFeedback .kcfb-msg b{font-weight:600;color:var(--kcfb-text)}',
      '#kcFeedback .kcfb-msg span{color:var(--kcfb-muted)}',

      /* foot */
      '#kcFeedback .kcfb-foot{flex:none;display:grid;gap:12px;padding:16px;border-top:1px solid var(--kcfb-line)}',
      '#kcFeedback .kcfb-send{width:100%;min-height:44px;padding:8px 16px;cursor:pointer;display:inline-flex;align-items:center;justify-content:center;gap:8px;',
      'border:0;border-radius:6px;background:var(--kcfb-red);color:#fff;font:500 15px/1.2 var(--kcfb-body);transition:background-color .12s ease}',
      '#kcFeedback .kcfb-send:hover{background:var(--kcfb-red-hover)}',
      '#kcFeedback .kcfb-send[disabled]{opacity:.5;cursor:not-allowed}',
      '#kcFeedback .kcfb-send[disabled]:hover{background:var(--kcfb-red)}',
      '#kcFeedback .kcfb-send[aria-busy="true"]{opacity:1;cursor:progress}',
      '#kcFeedback .kcfb-note{margin:0;font-size:13px;line-height:1.5;color:var(--kcfb-muted)}',
      '#kcFeedback .kcfb-note a{color:var(--kcfb-text);text-decoration:underline;text-underline-offset:2px;white-space:nowrap}',
      '#kcFeedback .kcfb-spin{width:16px;height:16px;flex:none;border-radius:999px;border:2px solid rgba(255,255,255,.35);border-top-color:#fff;',
      'animation:kcfbSpin .7s linear infinite}',
      '@keyframes kcfbSpin{to{transform:rotate(360deg)}}',
      '@media (prefers-reduced-motion:reduce){#kcFeedback .kcfb-spin{animation-duration:2s}}',

      /* sent */
      '#kcFeedback .kcfb-done{display:grid;justify-items:center;text-align:center;padding:32px 16px;outline:none}',
      '#kcFeedback .kcfb-tick{width:56px;height:56px;display:grid;place-items:center;margin-bottom:16px;border-radius:999px;color:var(--kcfb-ok);',
      'background:rgba(124,184,124,.12);border:1px solid rgba(124,184,124,.34)}',
      '#kcFeedback .kcfb-tick svg{width:28px;height:28px}',
      '#kcFeedback .kcfb-done h3{margin:0 0 16px;padding:0;font:600 20px/1.2 var(--kcfb-display);text-transform:uppercase;letter-spacing:-.03em;color:var(--kcfb-text)}',
      '#kcFeedback .kcfb-ref{display:inline-flex;align-items:center;gap:8px;min-height:44px;padding:8px 12px;border-radius:6px;',
      'background:var(--kcfb-raised);border:1px solid var(--kcfb-line);font-size:14px;color:var(--kcfb-muted)}',
      '#kcFeedback .kcfb-ref code{font:600 15px/1.2 ui-monospace,SFMono-Regular,Menlo,monospace;color:var(--kcfb-text);background:none;',
      'padding:0;border:0;white-space:nowrap;user-select:all}',
      '#kcFeedback .kcfb-done p{margin:8px 0 0;font-size:14px;color:var(--kcfb-muted)}',
      '#kcFeedback .kcfb-again{margin-top:24px;min-height:44px;padding:8px 16px;cursor:pointer;border-radius:6px;border:1px solid rgba(255,255,255,.16);',
      'background:var(--kcfb-card);color:var(--kcfb-text);font:500 15px/1.2 var(--kcfb-body);transition:background-color .12s ease}',
      '#kcFeedback .kcfb-again:hover{background:var(--kcfb-raised)}',

      /* focus, one ring everywhere */
      '#kcFeedback :is(.kcfb-launch,.kcfb-x,.kcfb-rm,.kcfb-send,.kcfb-again,.kcfb-note a,.kcfb-ctx summary):focus-visible{outline:2px solid var(--kcfb-focus);outline-offset:2px}',
      '#kcFeedback .kcfb-done:focus-visible{outline:none}',

      /* phone: a full-width sheet from the bottom, and no floating launcher.
         On a phone the button stacked with Back to top and the collection
         page's "Filter and sort" bar into three floating controls, so the
         phone menu opens the panel instead (the "Send
         feedback" button in snippets/header-drawer.liquid fires
         kc:feedback-open). */
      '@media (max-width:599px){',
      '#kcFeedback .kcfb-panel{left:0;right:0;bottom:0;width:auto;max-width:none;max-height:88vh;max-height:88dvh;border-radius:12px 12px 0 0;border-bottom:0}',
      '#kcFeedback .kcfb-launch{display:none}',
      '#kcFeedback .kcfb-chip{font-size:13px}',
      '}',
      /* Room under the footer below 1024px, where the last row of footer links
         (the legal pages) sits in the bottom right and the launcher would cover
         it for good at the end of the page. The page ends a launcher's height
         plus a gap lower, so those links scroll clear of it. The footer is in
         flow on a phone and absolutely positioned from 768px, so the room is
         padding on the footer itself. Only added while the widget is shown. */
      '@media (max-width:1023px){#PageContainer>footer.footer-group{padding-bottom:76px}}',
      /* A short screen (a phone on its side): the whole panel scrolls as one,
         so the message box is not squeezed out of view between the header and
         the Send area. */
      '@media (max-height:500px){#kcFeedback .kcfb-panel{overflow:auto;overscroll-behavior:contain}',
      '#kcFeedback .kcfb-body{flex:none;overflow:visible}}',

      /* The soft-launch overlay and the theme's own drawers and modals (cart,
         menu, search) win: the button must never sit over their controls. */
      'html.kc-soft-launch-gated #kcFeedback,body.has-modal-open #kcFeedback,body.has-modal-opening #kcFeedback{display:none}',
      '@media print{#kcFeedback{display:none}}'
    ].join('');

    var ICON = {
      chat: '<svg viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>',
      x: '<svg viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M18 6 6 18M6 6l12 12"/></svg>',
      check: '<svg viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m5 13 4 4L19 7"/></svg>',
      up: '<svg viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M4 16v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2M12 3v13M7 8l5-5 5 5"/></svg>',
      alert: '<svg viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="9"/><path d="M12 8v5M12 16h.01"/></svg>'
    };

    // ---- markup --------------------------------------------------------------
    var style = document.createElement('style');
    style.id = 'kcFeedbackStyle';
    style.textContent = CSS;
    (document.head || document.documentElement).appendChild(style);

    var root = document.createElement('div');
    root.id = 'kcFeedback';
    document.body.appendChild(root);

    function ctxRows() {
      var rows = [
        ['Page', safePath(location.pathname)],
        ['Signed in', account.signedIn ? 'yes' : 'no']
      ];
      if (account.member !== null) rows.push(['Membership', (account.status || '?') + ', ' + account.balance + ' credits']);
      rows.push(['Screen', window.innerWidth + ' x ' + window.innerHeight]);
      rows.push(['Recent actions', crumbs.length + ' recorded']);
      if (requestIds.length) rows.push(['Server refs', requestIds.length]);
      return rows.map(function (r) {
        return '<dt>' + esc(r[0]) + '</dt><dd>' + esc(r[1]) + '</dd>';
      }).join('');
    }

    function launcher() {
      return '<button class="kcfb-launch" id="kcFbLaunch" type="button" data-act="toggle" aria-expanded="' + open + '"' +
        (open ? ' aria-controls="kcFbPanel"' : '') + '>' + ICON.chat +
        '<span>Feedback</span></button>';
    }

    function head() {
      return '<div class="kcfb-head"><h2 id="kcFbTitle">Feedback</h2>' +
        '<button class="kcfb-x" id="kcFbClose" type="button" data-act="close" aria-label="Close feedback">' + ICON.x + '</button></div>';
    }

    function failBox() {
      var t = 'That did not send';
      var m = 'Your message is saved on this device, so nothing is lost. Check your connection and try again.';
      if (failReason === 'rate') {
        t = 'Too many messages just now';
        m = 'Your message is saved on this device. Wait a few minutes and try again.';
      } else if (failReason === 'too_large') {
        t = 'That was too large to send';
        m = 'Remove a screenshot and try again. Your message is saved on this device.';
      }
      return '<div class="kcfb-msg" role="alert">' + ICON.alert + '<b>' + esc(t) + '</b><span>' + esc(m) + '</span></div>';
    }

    function formPanel() {
      var d = draft();
      var type = typeOf(d.type);
      var body = String(d.body || '');
      var email = emailValue(d);
      var sending = phase === 'sending';
      var failed = phase === 'failed';
      var canSend = !sending && body.trim().length > 0;
      var left = MAX_BODY - body.length;

      var btn = sending
        ? '<button class="kcfb-send" id="kcFbSend" type="button" disabled aria-busy="true"><span class="kcfb-spin" aria-hidden="true"></span>Sending</button>'
        : '<button class="kcfb-send" id="kcFbSend" type="button" data-act="send"' + (canSend ? '' : ' disabled') + '>' +
          (failed ? 'Try again' : 'Send feedback') + '</button>';

      var chips = TYPES.map(function (t) {
        var on = t.v === type.v;
        return '<label class="kcfb-chip' + (on ? ' is-on' : '') + '"><input type="radio" id="kcFbT-' + t.v + '" name="kcFbType" value="' + t.v + '"' +
          (on ? ' checked' : '') + (sending ? ' disabled' : '') + '><span>' + esc(t.label) + '</span></label>';
      }).join('');

      var shotHtml = shots.length ? '<div class="kcfb-shots">' + shots.map(function (s, i) {
        return '<span class="kcfb-shot"><img src="' + esc(s.dataUrl) + '" alt="Screenshot ' + (i + 1) + '">' +
          '<button class="kcfb-rm" id="kcFbRm' + i + '" type="button" data-act="rm" data-i="' + i + '" aria-label="Remove screenshot ' + (i + 1) + '">' +
          ICON.x + '</button></span>';
      }).join('') + '</div>' : '';

      var drop = shots.length < MAX_FILES
        ? '<label class="kcfb-drop"><input type="file" id="kcFbFile" accept="image/png,image/jpeg,image/webp" multiple data-act="pick">' + ICON.up +
          '<span class="kcfb-drop-text"><b>Add a screenshot</b><small>Optional, up to 3 images</small></span></label>'
        : '';

      var note = tester
        ? 'Tester reports also include your recent clicks and account details, listed above. '
        : 'We include the page you\'re on and basic device info so we can fix things faster. ';

      return '<div class="kcfb-panel" id="kcFbPanel" role="dialog" aria-modal="false" aria-labelledby="kcFbTitle"' +
          (sending ? ' aria-busy="true"' : '') + '>' +
        head() +
        '<div class="kcfb-body"' + (sending ? ' inert' : '') + '>' +
          (failed ? failBox() : '') +
          '<fieldset class="kcfb-types"><legend class="kcfb-vh">What kind of feedback is this?</legend>' + chips + '</fieldset>' +
          '<div class="kcfb-field"><label class="kcfb-label" for="kcFbMsg">Tell us more</label>' +
            '<textarea class="kcfb-input" id="kcFbMsg" data-f="body" required aria-required="true" maxlength="' + MAX_BODY + '"' +
            (left <= MAX_BODY - COUNT_FROM ? ' aria-describedby="kcFbLeft"' : '') +
            ' placeholder="' + esc(type.hint) + '">' + esc(body) + '</textarea>' +
            (left <= MAX_BODY - COUNT_FROM ? '<p class="kcfb-help" id="kcFbLeft">' + left + ' characters left</p>' : '') +
          '</div>' +
          '<div class="kcfb-field">' + drop +
            (noteText ? '<p class="kcfb-help" role="status">' + esc(noteText) + '</p>' : '') +
            shotHtml +
          '</div>' +
          '<div class="kcfb-field"><label class="kcfb-label" for="kcFbEmail">Email for a reply <span class="kcfb-opt">Optional</span></label>' +
            '<input class="kcfb-input" id="kcFbEmail" data-f="email" type="email" autocomplete="email" inputmode="email" spellcheck="false"' +
            (emailError ? ' aria-invalid="true" aria-describedby="kcFbEmailErr"' : '') +
            ' value="' + esc(email) + '">' +
            (emailError ? '<p class="kcfb-help is-err" id="kcFbEmailErr">' + ICON.alert + 'Enter a full email address, or leave this empty.</p>' : '') +
          '</div>' +
          (tester
            ? '<details class="kcfb-ctx" id="kcFbCtx"><summary>Sent with this report</summary><dl>' + ctxRows() + '</dl></details>'
            : '') +
          '<div class="kcfb-hp" aria-hidden="true"><label for="kcFbWeb">Website</label>' +
            '<input id="kcFbWeb" name="website" type="text" tabindex="-1" autocomplete="off" data-hp></div>' +
        '</div>' +
        '<div class="kcfb-foot">' + btn +
          '<p class="kcfb-note">' + esc(note) + '<a href="' + PRIVACY_URL + '">Privacy Policy</a></p>' +
        '</div>' +
      '</div>';
    }

    function donePanel() {
      return '<div class="kcfb-panel" id="kcFbPanel" role="dialog" aria-modal="false" aria-labelledby="kcFbTitle">' +
        head() +
        '<div class="kcfb-done" id="kcFbDone" role="status" tabindex="-1">' +
          '<span class="kcfb-tick">' + ICON.check + '</span>' +
          '<h3>Thanks, we read every message</h3>' +
          '<span class="kcfb-ref">Ref <code>' + esc(lastRef || '') + '</code></span>' +
          '<p>Quote this reference if you contact us about it.</p>' +
          '<button class="kcfb-again" id="kcFbAgain" type="button" data-act="again">Send something else</button>' +
        '</div></div>';
    }

    /* Redraw, keeping focus (and the caret) where the person left it unless a
       target is named. Re-rendering is simple and the panel is small; losing
       the focus on every redraw is what would make it unusable by keyboard. */
    function render(focusSel) {
      var active = document.activeElement;
      var keepId = active && root.contains(active) && active.id ? active.id : null;
      var s0 = null, s1 = null;
      try { if (keepId && typeof active.selectionStart === 'number') { s0 = active.selectionStart; s1 = active.selectionEnd; } } catch (e) {}
      var ctx = root.querySelector('#kcFbCtx');
      var ctxOpen = ctx ? ctx.open : false;

      root.className = open ? 'is-open' : '';
      root.innerHTML = launcher() + (open ? (phase === 'sent' ? donePanel() : formPanel()) : '');

      var nctx = root.querySelector('#kcFbCtx');
      if (nctx && ctxOpen) nctx.open = true;
      var target = focusSel ? root.querySelector(focusSel) : (keepId ? root.querySelector('#' + keepId) : null);
      if (target) {
        try {
          target.focus({ preventScroll: true });
          if (!focusSel && s0 !== null && target.setSelectionRange) target.setSelectionRange(s0, s1);
        } catch (e) {}
      }
      syncFocusRings();
    }

    // :has() is not everywhere yet, so the ring on a chip or the upload box is
    // driven from here.
    function syncFocusRings() {
      var a = document.activeElement;
      var nodes = root.querySelectorAll('.kcfb-chip, .kcfb-drop');
      for (var i = 0; i < nodes.length; i++) {
        var inp = nodes[i].querySelector('input');
        var on = inp && a === inp && (function () { try { return inp.matches(':focus-visible'); } catch (e) { return true; } }());
        nodes[i].classList.toggle('is-focus', Boolean(on));
      }
    }
    root.addEventListener('focusin', function () { try { syncFocusRings(); } catch (e) {} });
    root.addEventListener('focusout', function () { setTimeout(function () { try { syncFocusRings(); } catch (e) {} }, 0); });

    function openPanel() {
      open = true;
      render('#kcFbMsg');
      if (tester) loadAccount().then(function () { if (open && phase !== 'sent') render(); });
    }
    // The phone menu has no launcher to press, so it asks for the panel with
    // this event (snippets/header-drawer.liquid).
    document.addEventListener('kc:feedback-open', function () { try { if (!open) openPanel(); } catch (e) {} });
    function closePanel() {
      open = false;
      if (phase === 'sent') { phase = 'idle'; lastRef = null; }
      emailError = false;
      render('#kcFbLaunch');
    }

    // ---- behaviour -----------------------------------------------------------
    root.addEventListener('input', function (ev) {
      try {
        var f = ev.target.getAttribute && ev.target.getAttribute('data-f');
        if (!f) return;
        var d = forgetKey(draft());
        d[f] = ev.target.value;
        saveDraft(d);
        if (f === 'email' && emailError && (!d.email.trim() || EMAIL.test(d.email.trim()))) {
          emailError = false;
          render();
          return;
        }
        if (f === 'body') {
          // Only the button and the counter depend on this, so they are updated
          // in place rather than re-rendering under the caret.
          var send = root.querySelector('.kcfb-send');
          if (send && phase !== 'sending') send.disabled = !String(d.body || '').trim();
          var left = MAX_BODY - String(d.body || '').length;
          var hasCount = Boolean(root.querySelector('#kcFbLeft'));
          if ((left <= MAX_BODY - COUNT_FROM) !== hasCount) render();
          else if (hasCount) root.querySelector('#kcFbLeft').textContent = left + ' characters left';
        }
      } catch (e) {}
    });

    root.addEventListener('change', function (ev) {
      try {
        var t = ev.target;
        if (t.getAttribute && t.getAttribute('data-act') === 'pick') { addFiles(t.files); return; }
        if (t.name === 'kcFbType') {
          var d = forgetKey(draft());
          d.type = t.value;
          saveDraft(d);
          var chips = root.querySelectorAll('.kcfb-chip');
          for (var i = 0; i < chips.length; i++) {
            var inp = chips[i].querySelector('input');
            chips[i].classList.toggle('is-on', Boolean(inp && inp.checked));
          }
          var ta = root.querySelector('#kcFbMsg');
          if (ta) ta.placeholder = typeOf(t.value).hint;
        }
      } catch (e) {}
    });

    root.addEventListener('click', function (ev) {
      try {
        var el = ev.target.closest('[data-act]');
        if (!el) return;
        var act = el.getAttribute('data-act');
        if (act === 'pick') return;
        if (act === 'toggle') { if (open) closePanel(); else openPanel(); return; }
        if (act === 'close') { closePanel(); return; }
        if (act === 'again') { phase = 'idle'; failReason = null; lastRef = null; shots = []; noteText = ''; render('#kcFbMsg'); return; }
        if (act === 'rm') { shots.splice(Number(el.getAttribute('data-i')), 1); saveDraft(forgetKey(draft())); render('#kcFbFile'); return; }
        if (act === 'send') { send(); return; }
      } catch (e) {}
    });

    document.addEventListener('keydown', function (ev) {
      try {
        if (ev.key === 'Escape' && open && phase !== 'sending') {
          // Only when the Escape belongs to us, or nothing else claimed it.
          if (root.contains(document.activeElement) || document.activeElement === document.body) closePanel();
        }
      } catch (e) {}
    });

    /*
     * Downscale in the browser before anything is sent. A phone screenshot is
     * commonly 2 to 4MB, and three of those base64-encoded would be rejected by
     * the platform long before they reached us. Resized to a 1600px longest edge
     * a screenshot is typically 150 to 400KB, still perfectly readable for
     * working out what went wrong, and it keeps storage small too.
     */
    function shrink(file) {
      return new Promise(function (resolve) {
        var url = URL.createObjectURL(file);
        var img = new Image();
        img.onload = function () {
          try {
            var w = img.naturalWidth, h = img.naturalHeight;
            var scale = Math.min(1, MAX_EDGE / Math.max(w, h));
            var cw = Math.max(1, Math.round(w * scale));
            var ch = Math.max(1, Math.round(h * scale));
            var c = document.createElement('canvas');
            c.width = cw; c.height = ch;
            c.getContext('2d').drawImage(img, 0, 0, cw, ch);
            // JPEG rather than PNG: a screenshot re-encoded as PNG can come out
            // LARGER than the original, which defeats the point.
            var out = c.toDataURL('image/jpeg', JPEG_Q);
            URL.revokeObjectURL(url);
            resolve({ dataUrl: out, w: cw, h: ch });
          } catch (e) {
            URL.revokeObjectURL(url);
            resolve(null);
          }
        };
        img.onerror = function () { URL.revokeObjectURL(url); resolve(null); };
        img.src = url;
      });
    }

    function addFiles(list) {
      var files = Array.prototype.slice.call(list || []);
      files.forEach(function (f) {
        if (shots.length >= MAX_FILES) return;
        if (!/^image\/(png|jpeg|webp)$/.test(f.type)) { note('That file is not an image.'); return; }
        if (f.size > MAX_SOURCE_BYTES) { note('That image is too big to attach.'); return; }
        shrink(f).then(function (r) {
          if (!r) { note('That image could not be read.'); return; }
          if (shots.length >= MAX_FILES) return;
          shots.push({ dataUrl: r.dataUrl, w: r.w, h: r.h });
          saveDraft(forgetKey(draft()));
          render(shots.length >= MAX_FILES ? '#kcFbRm' + (shots.length - 1) : '#kcFbFile');
        });
      });
    }

    /* A one-line reason shown under the attach control, so a rejected file is
       explained rather than silently ignored. */
    function note(msg) {
      noteText = msg;
      render();
      setTimeout(function () {
        if (noteText === msg) { noteText = ''; if (open) render(); }
      }, 5000);
    }

    function send() {
      var d = draft();
      if (!String(d.body || '').trim() || phase === 'sending') return;

      var email = String(emailValue(d) || '').trim();
      if (email && !EMAIL.test(email)) {
        emailError = true;
        render('#kcFbEmail');
        return;
      }
      emailError = false;

      // The honeypot is read straight off the page: no person can see or reach
      // it, so anything in it was put there by a script.
      var trapEl = root.querySelector('[data-hp]');
      var trap = trapEl ? trapEl.value : '';

      // Stable across retries, so a double tap or a retry after a timeout
      // produces ONE report and returns the SAME reference. Saved before the
      // request goes out, so a reload mid-send keeps it too. The email is not
      // written into the draft here: a saved account address was shown to the
      // next person on the same browser.
      var who = senderTag(email);
      if (d.key && typeof d.keyFor === 'string' && d.keyFor !== who) forgetKey(d);
      if (!d.key) { d.key = newKey(); d.keyFor = who; }
      if (!d.type) d.type = 'broken';
      saveDraft(d);

      // Stay inside the platform's request limit. Dropping the last image and
      // saying so beats a 413 that loses the whole report.
      var payloadShots = shots.slice();
      var total = payloadShots.reduce(function (n, s) { return n + s.dataUrl.length; }, 0);
      var droppedOne = false;
      while (payloadShots.length && total > WIRE_BUDGET) {
        var dropped = payloadShots.pop();
        total -= dropped.dataUrl.length;
        droppedOne = true;
      }
      if (droppedOne) noteText = 'One screenshot was too large to send and was left off.';

      phase = 'sending';
      failReason = null;
      render('#kcFbSend');

      var payload = {
        idempotencyKey: d.key,
        body: d.body,
        kind: typeOf(d.type).kind,
        contactEmail: email || null,
        website: trap,
        tester: tester,
        pageUrl: safePath(location.pathname) + location.search,
        device: { vw: window.innerWidth, vh: window.innerHeight, ua: navigator.userAgent, bypass: tester },
        requestIds: requestIds.slice(),
        screenshots: payloadShots.map(function (s) { return s.dataUrl; })
      };
      if (tester) {
        payload.referrer = document.referrer ? safePath(document.referrer) : null;
        payload.member = account.member;
        payload.balance = account.balance;
        payload.accountStatus = account.status;
        payload.breadcrumbs = crumbs.slice();
      }

      var ctrl = null, timer = null;
      try { ctrl = new AbortController(); timer = setTimeout(function () { ctrl.abort(); }, SEND_TIMEOUT); } catch (e) {}

      nativeFetch(ENDPOINT, {
        method: 'POST',
        headers: { 'content-type': 'application/json', accept: 'application/json' },
        body: JSON.stringify(payload),
        signal: ctrl ? ctrl.signal : undefined
      })
        .then(function (r) {
          if (r.status === 413) throw new Error('too_large');
          if (r.status === 429) throw new Error('rate');
          return r.json().then(function (j) { return { ok: r.ok, j: j }; }, function () { throw new Error('rejected'); });
        })
        .then(function (out) {
          // "Sent" only when the SERVER confirms the row. A finished upload is not
          // a commit, and telling someone it saved when it did not is the one
          // failure this widget must never have.
          if (!out.ok || !out.j || !out.j.ok || !out.j.ref) throw new Error('rejected');
          if (timer) clearTimeout(timer);
          lastRef = out.j.ref;
          phase = 'sent';
          shots = [];
          noteText = '';
          clearDraft();
          render('#kcFbDone');
        })
        .catch(function (e) {
          if (timer) clearTimeout(timer);
          phase = 'failed';   // the draft is deliberately left alone
          var m = e && e.message;
          failReason = m === 'too_large' || m === 'rate' ? m : (m === 'rejected' ? 'rejected' : 'network');
          render('#kcFbSend');
        });
    }

    render();
  }
}());
